const getHeaders = ({ rootState, headers = {} }) => ({
  ...headers,
  'x-fluke-token': rootState.auth.token,
})

module.exports = {
  getHeaders,
}
